/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { TechScreenMonitorOffIcon16Light } from './TechScreenMonitorOffIcon16Light';
import { TechScreenMonitorOffIcon16Regular } from './TechScreenMonitorOffIcon16Regular';
import { TechScreenMonitorOffIcon16Solid } from './TechScreenMonitorOffIcon16Solid';
import { TechScreenMonitorOffIcon20Light } from './TechScreenMonitorOffIcon20Light';
import { TechScreenMonitorOffIcon20Regular } from './TechScreenMonitorOffIcon20Regular';
import { TechScreenMonitorOffIcon20Solid } from './TechScreenMonitorOffIcon20Solid';
import { TechScreenMonitorOffIcon24Regular } from './TechScreenMonitorOffIcon24Regular';
import { TechScreenMonitorOffIcon24Solid } from './TechScreenMonitorOffIcon24Solid';
import { TechScreenMonitorOffIcon32Regular } from './TechScreenMonitorOffIcon32Regular';
import { TechScreenMonitorOffIcon64Regular } from './TechScreenMonitorOffIcon64Regular';
var sizes = {
    16: {
        light: TechScreenMonitorOffIcon16Light,
        regular: TechScreenMonitorOffIcon16Regular,
        solid: TechScreenMonitorOffIcon16Solid,
    },
    20: {
        light: TechScreenMonitorOffIcon20Light,
        regular: TechScreenMonitorOffIcon20Regular,
        solid: TechScreenMonitorOffIcon20Solid,
    },
    24: {
        regular: TechScreenMonitorOffIcon24Regular,
        solid: TechScreenMonitorOffIcon24Solid,
    },
    32: {
        regular: TechScreenMonitorOffIcon32Regular,
    },
    64: {
        regular: TechScreenMonitorOffIcon64Regular,
    },
};
export var TechScreenMonitorOffIcon = forwardRef('TechScreenMonitorOffIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
